// أسماء العرض لكل تاب تقرير - استخدمها في العنوان وقت الطباعة كمان
export const REPORT_TAB_LABELS = {
  comreport: "التقرير الشهري",
  programming: "قسم البرمجة",
  design: "قسم التصميم",
  other: "قسم أخرى",
  all: "جميع الأقسام",
};

// الترتيب اللي هيتعرض بيه التابات في السايدبار (ديسكتوب وموبايل)
// كل تاب بيظهر بس لو فيه بيانات جاية من الباك في reports[key]
export const REPORT_TABS = [
  { key: "comreport", label: "📊 التقرير الشهري" },
  { key: "programming", label: "💻 برمجة" },
  { key: "design", label: "🎨 تصميم" },
  { key: "other", label: "📁 أخرى" },
];
